import React, { forwardRef } from 'react';
import { InputMask } from 'utils/inputMask';

import { CalendarMIcon } from 'assets/icons';
import { useCustomInputPresenter } from './CustomInput.presenter';
import * as S from './CustomInput.styles';

const fn = () => {};

export const CustomInput = forwardRef((props) => {
  const {
    innerValue = '',
    disabled,
    onClick,
    onChange,
    onChangeInput = fn,
    onBlurInput = fn,
    dataTest,
    theme,
    ...rest
  } = props;

  const presenter = useCustomInputPresenter({ innerValue, onChange, onChangeInput, onBlurInput });

  return (
    <S.Input
      {...rest}
      mask={InputMask.DATE_UIKIT}
      unmask={false}
      value={presenter.localValue}
      onChange={presenter.changeHandler}
      onFocus={presenter.focusHandler}
      onBlur={presenter.blurHandler}
      onClick={onClick}
      disabled={disabled}
      data-test={dataTest}
      theme={theme}
      Icon={CalendarMIcon}
      iconPosition="right"
      isFocused={presenter.isFocused}
      hasValue={!!innerValue}
      spellCheck="false"
    />
  );
});

CustomInput.displayName = 'CustomInput';
